<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    mode="passive"
    :rules="rules"
  >
    <b-form-group :label="label" :description="description" :label-for="id">
      <input
        class="hidden"
        @change="onChange"
        type="file"
        :ref="defaultRef"
        :name="name"
        :accept="accept"
      />
      <b-input-group class="cursor-pointer">
        <b-form-input
          class="cursor-pointer"
          readonly
          :id="id"
          :placeholder="placeholder"
          :value="getFileName"
          @click="$refs[defaultRef].click()"
        />
        <b-input-group-append>
          <b-button
            @click="$refs[defaultRef].click()"
            size="sm"
            variant="outline-success"
            v-b-tooltip.hover.v-success.bottom
            title="رفع ملف"
          >
            <feather-icon icon="FilePlusIcon" size="18" />
          </b-button>
        </b-input-group-append>
        <b-input-group-append>
          <b-button
            :disabled="!getFileUrl"
            size="sm"
            variant="outline-info"
            v-b-tooltip.hover.v-info.bottom
            title="عرض الملف"
            target="_blank"
            :to="{ name: 'file-view', query: { ep: getFileUrl } }"
          >
            <feather-icon class="pt-25" icon="EyeIcon" size="20" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
      <small class="text-secondary"> يمكنك رفع ملغات بصيغة  {{ accept }}  و يجب ألا يتجاوز حجم الملف{{ sizeLimit }} ميغا </small>

    </b-form-group>
  </validation-provider>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import {
  BFormGroup,
  BFormFile,
  BInputGroupAppend,
  BFormInput,
  BButton,
  BInputGroup,
  VBTooltip,
} from "bootstrap-vue";
import { required } from "@validations";
import SizeValidationMixin from "@/utils/mixins/file-size-validation";
export default {
  components: {
    ValidationProvider,
    BFormGroup,
    BFormFile,
    BInputGroupAppend,
    BFormInput,
    BButton,
    BInputGroup,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  mixins: [SizeValidationMixin],
  props: {
    id: {
      type: String,
      default: () => "input",
    },
    name: {
      type: String,
    },
    refName: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
    accept: {
      type: String,
      default: () => "",
    },
    placeholder: {
      type: String,
      default: () => "أدرج ملفاً من جهازك ...",
    },
    sizeLimit: {
      type: String,
      default: () => '5',
    },
    value: {},
  },
  data() {
    return {
      required,
      fileUrl: null,
      fileName: null,
    };
  },
  computed: {
    defaultName() {
      return this.name || this.label;
    },
    defaultRef() {
      return this.refName || this.id;
    },
    getFileName() {
      return this.fileName
        ? this.fileName
        : this.value && typeof this.value === "string"
        ? this.value
        : null;
    },
    getFileUrl() {
      return this.fileUrl
        ? this.fileUrl
        : this.value && typeof this.value === "string"
        ? this.value
        : null;
    },
  },
  methods: {
    onChange(e) {
      var file = e.target.files[0];this.validateFileSize(file, parseInt(this.sizeLimit))
        .then(() => {
          this.fileName = file.name;
          this.fileUrl = URL.createObjectURL(file);
          this.$emit("input", file);
          this.$emit("change", e);
        })
        .catch(() => {
          this.$emit("input", null);
        });
    },
  },
};
</script>
